import { LoaderService } from '@/UtilService/loader.service';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';


@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
// isVisible = signal(false);
  constructor(public loaderService: LoaderService) {}
}
